import {useEffect, useState} from "react";
import "../../css/modal/PaymentHistoryModal.css"
import proxy from "../../utils/Proxy";
import Pagination from "../footer/Pagination";
import {calculateHoldingDays, getDateString, isValidDate, limitInputNumber, moveModal} from "../../utils/Utils";
import PaymentMethods from "../../utils/constants/PaymentMethods";
import HoldingStatus from "../../utils/constants/HoldingStatus";

let PaymentHistoryModal = (props) => {
    let [paymentList, setPaymentList] = useState([]);
    let [page, setPage] = useState(1);
    let [listLength, setListLength] = useState(0);
    let [needUpdate, setNeedUpdate] = useState(false);
    let [holdingsModalOpen, setHoldingsModalOpen] = useState(false);
    let [selectedUserHoldings, setSelectedUserHoldings] = useState([]);
    let [selectedUsername, setSelectedUsername] = useState("");
    let [selectedPayment, setSelectedPayment] = useState(null);
    let [dateInputs, setDateInputs] = useState({});
    let [maxHoldingInputs, setMaxHoldingInputs] = useState({});

    let onRefundClick = (e) => {
        let splits = e.currentTarget.id.split(":");
        let paymentId = parseInt(splits[1]);
        let isCancelRefund = splits[0] === "refund-cancel";
        let refund_amount;
        let refund_confirm = false;

        if (!isCancelRefund) {
            refund_amount = window.prompt("환불할 금액을 입력하세요.")
            if (refund_amount === null)
                return;
            refund_confirm = true;
        } else {
            refund_confirm = window.confirm("환불 취소하시겠습니까?");
            refund_amount = -1;
        }
        if (refund_confirm) {
            proxy.delete("/adminapi/payments/" + paymentId + "?refund_amount=" + refund_amount).then(res => {
                let message = res.data.message;
                setNeedUpdate(!needUpdate)
                window.alert(message);
            }).catch(err => {
                window.alert(err.response.data.message)
            })
        }
    }

    let onHoldingClick = async (payment) => {
        try {
            const response = await proxy.get(`/adminapi/holdings?paymentid=${payment.paymentid}`);
            setSelectedUserHoldings(response.data.data);
            setSelectedUsername(props.username);
            setSelectedPayment(payment);
            setHoldingsModalOpen(true);
        } catch (error) {
            console.error("홀딩 정보 조회 실패:", error);
            window.alert("홀딩 정보 조회 중 오류가 발생했습니다.");
        }
    }

    let closeHoldingsModal = () => {
        setHoldingsModalOpen(false);
        setSelectedUserHoldings([]);
        setSelectedUsername("");
    }

    let handleHoldingCancel = async (holdingid) => {
        if (!window.confirm("홀딩 신청을 취소하시겠습니까?")) {
            return;
        }

        try {
            const response = await proxy.delete(`/adminapi/holdings/${holdingid}`);
            if (response.status === 200) {
                window.alert("홀딩 신청이 취소되었습니다.");
                // 홀딩 목록 새로고침
                if (selectedPayment) {
                    const refreshResponse = await proxy.get(`/adminapi/holdings?paymentid=${selectedPayment.paymentid}`);
                    setSelectedUserHoldings(refreshResponse.data.data);
                }
                setNeedUpdate(!needUpdate);
            } else {
                window.alert("홀딩 취소에 실패했습니다.");
            }
        } catch (error) {
            console.error("홀딩 취소 실패:", error);
            if (error.response?.status === 406) {
                window.alert("대기중인 홀딩만 취소할 수 있습니다.");
            } else {
                window.alert("홀딩 취소 중 오류가 발생했습니다.");
            }
        }
    }

    let handleMaxHoldingAmountChange = (e, paymentid) => {
        const value = parseInt(e.target.value) || 0;
        
        // maxHoldingInputs state에서 해당 payment의 값을 업데이트
        setMaxHoldingInputs(prev => ({
            ...prev,
            [paymentid]: value
        }));
    }



    let handleDateChange = (e, paymentid, field, type) => {
        const value = e.target.value;
        setDateInputs(prev => ({
            ...prev,
            [`${paymentid}_${field}_${type}`]: value
        }));
    }

    let getHoldingsModalContent = () => {
        if (selectedUserHoldings.length === 0) {
            return <div className="holdings-modal-empty">홀딩 정보가 없습니다.</div>;
        }

        return (
            <div className="holdings-modal-content">
                <div className="holdings-modal-table">
                    <div className="holdings-modal-table-header">
                        <div className="holdings-modal-cell">시작일</div>
                        <div className="holdings-modal-cell">종료일</div>
                        <div className="holdings-modal-cell">신청일</div>
                        <div className="holdings-modal-cell">홀딩 신청일수</div>
                        <div className="holdings-modal-cell">상태</div>
                        <div className="holdings-modal-cell">처리</div>
                    </div>
                    {selectedUserHoldings.map((holding, index) => (
                        <div key={index} className="holdings-modal-row">
                            <div className="holdings-modal-cell">
                                {getDateString(new Date(holding.start))}
                            </div>
                            <div className="holdings-modal-cell">
                                {getDateString(new Date(holding.end))}
                            </div>
                            <div className="holdings-modal-cell">
                                {getDateString(new Date(holding.holded_at))}
                            </div>
                            <div className="holdings-modal-cell">
                                {calculateHoldingDays(holding.start, holding.end)}일/최대 {selectedPayment.max_holding_amount}일
                            </div>
                            <div className="holdings-modal-cell">
                                <span className={HoldingStatus.getStatusClass(holding.is_resolved)}>
                                    {HoldingStatus.getStatusText(holding.is_resolved)}
                                </span>
                            </div>
                            <div className="holdings-modal-cell">
                                <div className="holding-action-buttons">
                                    {holding.is_resolved !== HoldingStatus.ACCEPTED && (
                                        <button 
                                            className="holding-accept-button"
                                            onClick={() => handleHoldingAction(holding.holdingid, HoldingStatus.ACCEPTED)}
                                        >
                                            승인
                                        </button>
                                    )}
                                    {holding.is_resolved !== HoldingStatus.REJECTED && (
                                        <button 
                                            className="holding-reject-button"
                                            onClick={() => handleHoldingAction(holding.holdingid, HoldingStatus.REJECTED)}
                                        >
                                            거절
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    let handleHoldingAction = async (holdingid, newStatus) => {
        const action = newStatus === HoldingStatus.ACCEPTED ? "승인" : "거절";
        const confirmMessage = `홀딩을 ${action}하시겠습니까?`;
        
        if (!window.confirm(confirmMessage)) {
            return;
        }

        try {
            await proxy.put(`/adminapi/holdings/${holdingid}`, {
                is_resolved: newStatus
            });
            
            window.alert(`홀딩이 성공적으로 ${action}되었습니다.`);
            
            // 홀딩 목록 새로고침
            if (selectedPayment) {
                const refreshResponse = await proxy.get(`/adminapi/holdings?paymentid=${selectedPayment.paymentid}`);
                setSelectedUserHoldings(refreshResponse.data.data);
            }
            
            // PaymentList 강제 업데이트 (used_holding_amount와 end 날짜가 변경될 수 있음)
            const paymentResponse = await proxy.get(`/adminapi/payments/users/${props.userid}?page=${page}&count=4`);
            const data = paymentResponse.data;
            setListLength(data.totalLength);
            setPaymentList(data.data);
        
        } catch (error) {
            console.error("홀딩 처리 실패:", error);
            window.alert(`홀딩 ${action} 중 오류가 발생했습니다.`);
        }
    };

    let onSubmitClick = (_) => {
        let requests = {};
        for (let payment of paymentList) {
            let paymentid = payment.paymentid;
            requests[paymentid] = {};
            let start_container = document.getElementById("payment-startdate:" + paymentid)
            let end_container = document.getElementById("payment-enddate:" + paymentid)

            let etcInput = document.getElementById("payment-etc:" + paymentid);
            if (etcInput.defaultValue !== etcInput.value) {
                requests[paymentid].etc = etcInput.value;
            }

            // max_holding_amount 변경사항 처리 - maxHoldingInputs state에서 가져오기
            if (maxHoldingInputs[paymentid] !== undefined && maxHoldingInputs[paymentid] !== payment.max_holding_amount) {
                requests[paymentid].max_holding_amount = maxHoldingInputs[paymentid];
            }

            let inputStart = ""
            let inputEnd = ""
            for (let child of start_container.childNodes) {
                if (child.value === "") {
                    continue;
                }
                let valueDate = parseInt(child.value);
                if (valueDate < 10)
                    valueDate = "0" + valueDate;
                inputStart += valueDate + "-"
            }
            for (let child of end_container.childNodes) {
                if (child.value === "") {
                    continue;
                }
                let valueDate = parseInt(child.value);
                if (valueDate < 10)
                    valueDate = "0" + valueDate;
                inputEnd += valueDate + "-"
            }

            inputStart = inputStart.slice(0, -1)
            inputEnd = inputEnd.slice(0, -1)

            if (payment.startdate_non_set) { //시작일 미정자의 경우
                if (inputStart.length > 0 && inputEnd.length > 0) { //시작일 미정자이고, 입력된게 무언가 있을 때
                    if (!isValidDate(inputStart) || !isValidDate(inputEnd)) { //입력값이 잘못된 경우
                        return alert("잘못된 날짜 값입니다. 확인 후 다시 시도해주세요.");
                    }
                    requests[paymentid].start = inputStart;
                    requests[paymentid].end = inputEnd;
                } else {
                    requests[paymentid].start = undefined;
                    requests[paymentid].end = undefined;
                }
            } else {
                if (!isValidDate(inputStart) || !isValidDate(inputEnd) || inputStart > inputEnd) { //입력값이 잘못된 경우
                    return alert("잘못된 날짜 값입니다. 확인 후 다시 시도해주세요.");
                }
                requests[paymentid].start = inputStart;
                requests[paymentid].end = inputEnd;
            }
        }
        requestPaymentModify(requests).then(() => {
            setNeedUpdate(true);
            window.alert("변경 사항이 저장되었습니다.");
        });
    }
    let requestPaymentModify = async (requests) => {
        for (let paymentid in requests) {
            await proxy.put("/adminapi/payments/" + paymentid, requests[paymentid])
        }
    }


    let getPaymentHistory = () => {
        let ret = [];
        for (let payment of paymentList) {
            let startDate = payment.start;
            let endDate = payment.end;

            let dateInfo = {
                startYear: "",
                startMonth: "",
                startDateNumber: "",
                endYear: "",
                endMonth: "",
                endDateNumber: ""
            }

            if (startDate !== null) {
                let dateObj = new Date(startDate);
                dateInfo.startYear = dateObj.getFullYear();
                dateInfo.startMonth = dateObj.getMonth() + 1;
                dateInfo.startDateNumber = dateObj.getDate();
            }
            if (endDate !== null) {
                let dateObj = new Date(endDate);
                dateInfo.endYear = dateObj.getFullYear();
                dateInfo.endMonth = dateObj.getMonth() + 1;
                dateInfo.endDateNumber = dateObj.getDate();
            }

            // dateInputs에서 저장된 값이 있으면 사용, 없으면 기본값 사용
            const getDateValue = (field, type) => {
                const key = `${payment.paymentid}_${field}_${type}`;
                return dateInputs[key] !== undefined ? dateInputs[key] : dateInfo[`${field}${type}`];
            };

            // maxHoldingInputs에서 저장된 값이 있으면 사용, 없으면 기본값 사용
            const getMaxHoldingValue = () => {
                return maxHoldingInputs[payment.paymentid] !== undefined 
                    ? maxHoldingInputs[payment.paymentid] 
                    : (payment.max_holding_amount || 0);
            };

            let key = "payment:" + payment.paymentid;
            let refund_id = payment.refunded ? "refund-cancel:" + payment.paymentid : "refund:" + payment.paymentid;
            let etc_id = "payment-etc:" + payment.paymentid;
            let startDate_id = "payment-startdate:" + payment.paymentid;
            let endDate_id = "payment-enddate:" + payment.paymentid;

            let methods = PaymentMethods.getPaymentMethodTexts(payment.method);
            let methodString = methods.join(", ");

            ret.push(<div className="payment-history-table-row" key={key} id={key}>
                <div className="payment-history-element-cell">
                    <p>{getDateString(new Date(payment.payment_date))}</p>
                </div>
                <div className="payment-history-element-cell">
                    {/*startDate*/}
                    <div className="payment-history-date-container">
                                                         <div className="payment-history-date-cell">
                                 <div className="payment-history-date_input-container" id={startDate_id}>
                                     <input className="payment-history-date-input payment-date-year"
                                            value={getDateValue("start", "Year")} 
                                            onChange={(e) => handleDateChange(e, payment.paymentid, "start", "Year")}
                                            type="number"/>
                                     <input className="payment-history-date-input payment-date-month"
                                            value={getDateValue("start", "Month")} 
                                            onChange={(e) => handleDateChange(e, payment.paymentid, "start", "Month")}
                                            type="number"/>
                                     <input className="payment-history-date-input payment-date-datenumber"
                                            value={getDateValue("start", "DateNumber")} 
                                            onChange={(e) => handleDateChange(e, payment.paymentid, "start", "DateNumber")}
                                            type="number"/>
                                 </div>
                             </div>
                        <div className="payment-history-date-cell">
                            <p>~</p>
                        </div>
                                                 {/*endDate*/}
                         <div className="payment-history-date-cell">
                             <div className="payment-history-date_input-container" id={endDate_id}>
                                 <input className="payment-history-date-input payment-date-year"
                                        value={getDateValue("end", "Year")} 
                                        onChange={(e) => handleDateChange(e, payment.paymentid, "end", "Year")}
                                        type="number"/>
                                 <input className="payment-history-date-input payment-date-month"
                                        value={getDateValue("end", "Month")} 
                                        onChange={(e) => handleDateChange(e, payment.paymentid, "end", "Month")}
                                        type="number"/>
                                 <input className="payment-history-date-input payment-date-datenumber"
                                        value={getDateValue("end", "DateNumber")} 
                                        onChange={(e) => handleDateChange(e, payment.paymentid, "end", "DateNumber")}
                                        type="number"/>
                             </div>
                         </div>
                    </div>
                </div>
                <div className="payment-history-element-cell">
                    <p>{payment.lesson_count}</p>
                </div>
                <div className="payment-history-element-cell">
                    <p>{payment.payment_amount}</p>
                </div>
                <div className="payment-history-element-cell">
                    <p>{methodString}</p>
                </div>
                <div className="payment-history-element-cell">
                    <p>{payment.refunded_amount}</p>
                </div>
                <div className="payment-history-element-cell">
                    {payment.refunded ? (
                        <div className="payment-history-refund-button" id={refund_id} onClick={onRefundClick}>
                            <p>취소</p>
                        </div>) : (
                        <div className="payment-history-refund-button" id={refund_id} onClick={onRefundClick}>
                            <p>환불</p>
                        </div>)}
                </div>
                <div className="payment-history-element-cell">
                    <div className="payment-history-etc-container">
                        <textarea className="payment-history-etc-input"
                                  defaultValue={payment.etc === null ? "" : payment.etc} id={etc_id}
                                  onChange={e => {
                                      limitInputNumber(e, 60)
                                  }}
                        />
                    </div>
                </div>
                <div className="payment-history-element-cell">
                    <input 
                        type="number" 
                        value={getMaxHoldingValue()} 
                        onChange={(e) => handleMaxHoldingAmountChange(e, payment.paymentid)}
                        min="0"
                        className="max-holding-table-input"
                    />
                </div>
                <div className="payment-history-element-cell">
                    <p>{payment.used_holding_amount || 0}</p>
                </div>
                <div className="payment-history-element-cell">
                    <button 
                        className={`payment-history-holding-button`} 
                        onClick={() => onHoldingClick(payment)}
                    >
                        홀딩
                    </button>
                </div>
            </div>)
        }
        return ret;
    }
    useEffect(() => {
        proxy.get("/adminapi/payments/users/" + props.userid + "?page=" + page + "&count=" + 4).then(res => {
            let data = res.data;
            let totalLength = data.totalLength;
            let list = data.data;

            setListLength(totalLength)
            setPaymentList(list)
        }).catch(err => {
            window.alert(err.response.data.message);
        })
    }, [page, needUpdate, props.userid])


    return (<div className="modal-container child-modal-container">
        <div className="modal" id="payment-history-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "payment-history-modal")}>
                    <p className="modal-title">
                        {props.username} 님의 결제 목록 (남은 레슨 횟수: {props.lesson_count})
                    </p>
                    <div className="modal-close-button" onClick={() => {
                        props.setOpened(false)
                    }}></div>
                </div>
                <div className="modal-content payment-history-content">
                    <div className="payment-history-table-container">
                        <div className="payment-history-table-header">
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">일시</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">기간</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">레슨 횟수</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">결제 금액</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">결제 수단</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">환불 금액</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">환불</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">비고</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">최대 홀딩</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">사용된 홀딩</p>
                            </div>
                            <div className="payment-history-element-cell">
                                <p className="history-header-text">홀딩</p>
                            </div>
                        </div>
                        <div className="payment-history-table">
                            {getPaymentHistory()}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <Pagination page={page} setPage={setPage.bind(this)} listLength={listLength}
                                countPerPage={4}
                    ></Pagination>
                    <div className="modal-footer-button-container">
                        <div className="modal-button" onClick={onSubmitClick}>
                            <p>변경사항 저장</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        {/* 홀딩 정보 모달 */}
        {holdingsModalOpen && (
            <div className="holdings-modal-overlay" onClick={closeHoldingsModal}>
                <div className="holdings-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="holdings-modal-header">
                        <div>
                            <h3>{selectedUsername} 님의 홀딩 정보</h3>
                            <div className="holdings-info">
                                <p>홀딩: {selectedPayment.used_holding_amount}/{selectedPayment.max_holding_amount}회 
                                    (잔여: {selectedPayment.max_holding_amount - selectedPayment.used_holding_amount}회)</p>
                            </div>
                        </div>
                        <button className="holdings-modal-close" onClick={closeHoldingsModal} />
                    </div>
                    {getHoldingsModalContent()}
                </div>
            </div>
        )}
    </div>)
}
export default PaymentHistoryModal